import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import TnC from "../components/TnC";

export default withRouter(connect()(TnC));
